import React, { useEffect } from "react";
import classes from "./Aboutus.module.css";
import { Link } from "react-router-dom";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";

function Aboutus() {
  const [fade, api] = useSpring(() => ({
    opacity: 0,
    config: { delay: 500, duration: 1000 },
  }));

  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      api.start({
        opacity: 1,
        config: { delay: 500, duration: 3000 },
      });
    }
  }, [api, inView]);

  return (
    <animated.aside className={classes.Aboutus} style={fade} ref={ref}>
      <h2 className={classes.AboutusTitle}>
        About <span>Us</span>
      </h2>
      <div className={classes.AboutusContent}>
        <p className={classes.AboutusText}>
          All Africa Hub is incubation; co-working, training and business
          development center for all African innovators, inventors,
          entrepreneurs and investors meet each other and share experiences.
        </p>
        <Link className={classes.AboutusLink} to="/aboutus">
          About
        </Link>
      </div>
    </animated.aside>
  );
}

export default Aboutus;
